import React, { useState } from "react";
import { Button, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
import {
  removeFromFavorites,
  addToCart,
  calculateDiscountedPrice,
} from "../../utils/localStorage";
import { DEFAULT_IMAGE_URL } from "../../config/apiConfig";

const ProductFavorite = ({ product, onUpdateFavorites }) => {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [quantity] = useState(1);

  // حساب السعر بعد الخصم
  const discountedPrice = calculateDiscountedPrice(
    product.price,
    product.discount
  );
  const originalPrice = parseFloat(product.price);

  // دالة إزالة من المفضلة
  const handleRemoveFromFavorites = (e) => {
    e.stopPropagation();
    const success = removeFromFavorites(product.product_id);
    if (success) {
      message.success("تم إزالة المنتج من المفضلة بنجاح!");
      onUpdateFavorites(); // تحديث قائمة المفضلة
    } else {
      message.error("فشل في إزالة المنتج من المفضلة");
    }
  };

  // دالة إضافة إلى السلة
  const handleAddToCart = (e) => {
    e.stopPropagation();

    // إنشاء كائن المنتج للسلة
    const productForCart = {
      product_id: product.product_id,
      variation_id: product.variation_id,
      name: product.item_name,
      price: product.price,
      default_sales_discount: product.discount,
      image_url: product.icon,
      stock: product.stock,
    };

    const success = addToCart(productForCart, quantity);
    if (success) {
      message.success("تم إضافة المنتج إلى السلة بنجاح!");
    } else {
      message.error("فشل في إضافة المنتج إلى السلة");
    }
  };

  const closeModal = () => setIsModalOpen(false);

  const navigateToLogin = () => {
    setIsModalOpen(false);
    navigate("/Login");
  };

  return (
    <>
      <div className="group overflow-hidden cursor-pointer relative bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
        {/* زر إزالة من المفضلة */}
        <div className="absolute top-2 right-2 z-20">
          <button
            onClick={handleRemoveFromFavorites}
            className="bg-red-500 hover:bg-red-600 text-white w-8 h-8 rounded-full flex items-center justify-center transition-colors"
          >
            <FontAwesomeIcon icon={faTrash} size="sm" />
          </button>
        </div>

        {/* صورة المنتج */}
        <div className="bg-gray-100 w-full overflow-hidden">
          <img
            src={
              product.icon || DEFAULT_IMAGE_URL
            }
            alt={product.item_name}
            className="aspect-[3/4] w-full object-cover object-top hover:scale-110 transition-all duration-700"
            loading="lazy"
            onError={(e) => {
              e.target.src = DEFAULT_IMAGE_URL;
            }}
          />
        </div>

        {/* معلومات المنتج */}
        <div className="p-4 relative">
          {/* أزرار الإجراءات */}
          <div className="flex flex-nowrap justify-between gap-2 w-full absolute px-4 pt-3 z-10 transition-all duration-500 left-0 right-0 group-hover:bottom-24 lg:bottom-5 lg:opacity-0 lg:bg-white lg:group-hover:opacity-100 max-lg:bottom-20 max-lg:py-3 max-lg:bg-white/60">
            <Button
              onClick={() =>
                navigate(`/Products/${product.item_id || product.product_id}`)
              }
              type="primary"
              size="middle"
              className="flex-1"
            >
              عرض المنتج
            </Button>
            <Button
              onClick={handleAddToCart}
              size="middle"
              className="flex-1"
              icon={<FontAwesomeIcon icon={faShoppingCart} />}
            >
              إضافة للسلة
            </Button>
          </div>

          {/* تفاصيل المنتج */}
          <div className="z-20 bg-white">
            <h6 className="text-sm font-semibold text-gray-800 line-clamp-2 mb-2">
              {product.item_name}
            </h6>

            {/* الأسعار */}
            <div className="flex justify-between items-center mb-2">
              {product.discount > 0 ? (
                <>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-green-600">
                      EGP {parseFloat(discountedPrice).toFixed(0)}
                    </span>
                    <span className="text-xs text-gray-500 line-through">
                      EGP {originalPrice.toFixed(0)}
                    </span>
                  </div>
                  <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded">
                    {product.discount}% خصم
                  </span>
                </>
              ) : (
                <span className="text-sm font-bold text-gray-800">
                  EGP {originalPrice.toFixed(0)}
                </span>
              )}
            </div>


          </div>
        </div>
      </div>

      {/* Modal تسجيل الدخول */}
      <Modal
        title="تنبيه"
        open={isModalOpen}
        onCancel={closeModal}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            إغلاق
          </Button>,
          <Button key="login" type="primary" onClick={navigateToLogin}>
            تسجيل الدخول
          </Button>,
        ]}
      >
        <p>عذرًا، يجب تسجيل الدخول لإضافة المنتجات إلى السلة.</p>
      </Modal>
    </>
  );
};

export default ProductFavorite;
